import type { ReactNode } from 'react';
import { Stack, Text } from '@mantine/core';
import PageTitle from '@/components/common/PageTitle';

interface AuthCardProps {
  readonly title: string;
  readonly description?: ReactNode;
  readonly children: ReactNode;
  /** Нижний блок ссылок (вход/регистрация/отмена). */
  readonly footer?: ReactNode;
}

// Единый блок экранов входа: заголовок, описание, содержимое и ссылки внизу. Без рамки и тени: «Бюллетень» разделяет
// блоки линиями и пространством.
export default function AuthCard({ title, description, children, footer }: AuthCardProps) {
  return (
    <Stack gap="lg">
      <Stack gap={6}>
        <PageTitle c="var(--mantine-color-text)" fz={{ base: 26, sm: 30 }}>
          {title}
        </PageTitle>
        {description ? (
          <Text c="gray.7" size="sm">
            {description}
          </Text>
        ) : null}
      </Stack>

      {children}

      {footer ? <Stack gap="xs">{footer}</Stack> : null}
    </Stack>
  );
}
